import { triggerHaptic } from "@/lib/haptic-feedback";
import type { Data } from "@/types/data";
import { FaWhatsapp } from "react-icons/fa";

interface ButtonWhatsAppProps {
	data: Data;
}

const ButtonWhatsApp = ({ data }: ButtonWhatsAppProps) => {
	const whatsapp = data.cliente["redes-sociais"].find((social) =>
		social.nome.toLowerCase().includes("whatsapp"),
	);

	if (!whatsapp) {
		return null;
	}

	return (
		<a
			href={whatsapp.url}
			target="_blank"
			rel="noopener noreferrer"
			onClick={() => triggerHaptic("light")}
			className="animate-float-soft fixed right-4 bottom-5 z-[9999] inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-600 text-white shadow-lg shadow-brand-900/25 transition-all duration-200 hover:scale-105 hover:bg-emerald-600 active:scale-[0.97] md:h-16 md:w-16"
			aria-label="Falar no WhatsApp"
		>
			<FaWhatsapp className="h-8 w-8 md:h-9 md:w-9" />
		</a>
	);
};

export default ButtonWhatsApp;
